<div *ngIf="icon" class="iconDs__cont iconDs__fill--{{color}}" [ngStyle]="{ width: maxSize + 'px' }">
  <svg
    class="iconDs__svg {{icon}}"
    [attr.fill]="'none'"
    [attr.width]="maxSize"
    [attr.height]="maxSize"
    [attr.viewBox]="viewBox"
    [attr.xmlns]="'http://www.w3.org/2000/svg'">
    <g *ngFor="let graphic of graphics">
      <mask *ngIf="graphic.mask" [attr.id]="graphic.mask?.id" [attr.fill]="graphic.mask?.fill">
        <path class="fill-disabled" [attr.d]="graphic.mask?.d"/>
      </mask>

      <g *ngIf="graphic.gradient">
        <path [attr.d]="graphic.gradient?.d" [attr.fill]="graphic.gradient?.fill" />
        <defs>
          <linearGradient
            [attr.id]="graphic.gradient?.id"
            [attr.x1]="graphic.gradient?.x1"
            [attr.y1]="graphic.gradient?.y1"
            [attr.x2]="graphic.gradient?.x2"
            [attr.y2]="graphic.gradient?.y2"
            [attr.gradientUnits]="graphic.gradient?.gradientUnits">
            <stop *ngFor="let stop of graphic.gradient?.stops" [attr.offset]="stop.offset" [attr.stop-color]="stop.stopColor"></stop>
          </linearGradient>
        </defs>
      </g>

      <path *ngIf="graphic.d"
        fill-rule="evenodd"
        clip-rule="evenodd"
        vector-effect="non-scaling-stroke"
        [class.fill-disabled]="graphic.stroke?.fillIsDisabled"
        [class.stroke-color]="graphic.stroke?.strokeColor"
        [attr.d]="graphic.d"
        [attr.mask]="vectorProps(graphic, 'var(--ink-strong)')?.mask ?? null"
        [attr.stroke]="vectorProps(graphic, 'var(--ink-strong)')?.stroke ?? null"
        [attr.fill]="vectorProps(graphic, 'var(--ink-strong)')?.fill ?? null"
        [attr.stroke-width]="vectorProps(graphic, 'var(--ink-strong)')?.['stroke-width'] ?? null"/>

      <rect *ngIf="graphic.rect"
        [class.fill-disabled]="graphic.stroke?.fillIsDisabled"
        [class.stroke-color]="graphic.stroke?.strokeColor"
        [attr.x]="graphic.rect.x"
        [attr.y]="graphic.rect.y"
        [attr.width]="graphic.rect.width"
        [attr.height]="graphic.rect.height"
        [attr.rx]="graphic.rect.rx"
        [attr.fill]="vectorProps(graphic, 'var(--ink-strong)')?.fill ?? null"
        [attr.stroke]="vectorProps(graphic, 'var(--ink-strong)')?.stroke ?? null"
        [attr.stroke-width]="vectorProps(graphic, 'var(--ink-strong)')?.['stroke-width'] ?? null"/>

      <ellipse *ngIf="graphic.ellipse"
        [attr.cx]="graphic.ellipse.cx"
        [attr.cy]="graphic.ellipse.cy"
        [attr.rx]="graphic.ellipse.rx"
        [attr.ry]="graphic.ellipse.ry"
        [attr.fill]="vectorProps(graphic, 'var(--ink-strong)')?.fill ?? null"
        [attr.stroke]="vectorProps(graphic, 'var(--ink-strong)')?.stroke ?? null"
        [attr.stroke-width]="vectorProps(graphic, 'var(--ink-strong)')?.['stroke-width'] ?? null"/>

      <circle *ngIf="graphic.circle"
        [class.fill-disabled]="graphic.stroke?.fillIsDisabled"
        [class.stroke-color]="graphic.stroke?.strokeColor"
        [attr.cx]="graphic.circle.cx"
        [attr.cy]="graphic.circle.cy"
        [attr.r]="graphic.circle.r"
        [attr.stroke]="vectorProps(graphic, 'var(--ink-strong)')?.stroke ?? null"
        [attr.fill]="vectorProps(graphic, 'var(--ink-strong)')?.fill ?? null"
        [attr.stroke-width]="vectorProps(graphic, 'var(--ink-strong)')?.['stroke-width'] ?? null"/>

      <polygon *ngIf="graphic.points"
        [class.fill-disabled]="graphic.stroke?.fillIsDisabled"
        [class.stroke-color]="graphic.stroke?.strokeColor"
        [attr.points]="graphic.points"
        [attr.fill]="vectorProps(graphic, 'var(--ink-strong)')?.fill ?? null"
        [attr.stroke]="vectorProps(graphic, 'var(--ink-strong)')?.stroke ?? null"
        [attr.stroke-width]="vectorProps(graphic, 'var(--ink-strong)')?.['stroke-width'] ?? null">
      </polygon>
    </g>
  </svg>
</div>